import React from "react";
import ReactDom from "react-dom";
import App from "./App";
import "./index.css"
import { StateProvider } from "./StateProvider";
import reducer, { initialState } from "./reducer";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { faTwitter, faFontAwesome } from "@fortawesome/free-brands-svg-icons";

library.add(fas, faTwitter, faFontAwesome);

 ReactDom.render(
    <React.StrictMode>
      <StateProvider initialState={initialState} reducer={reducer}>
        <App/>
      </StateProvider>
    </React.StrictMode>, document.getElementById("root"));


